export const IMAGES = {
  erekleMin: 'erekle-min.png',
  ananuri: "ananuri.jpg",

  pshavlebi: "Pshavela.jpg",
  pshavlebiMin: "pshavela-min.png",

  xevsurebi: "Xevsurebi.jpg",
  xevsurebiMin: "xevsurebi-min.png",

  blackChokhars: "shavchoxosnebi.png",
  blackChokharsMin: "shavchoxosnebi-min.png",

  persians: "persian.jpeg",
  persiansMin: "persian-min.png",

  // sidesGeo: 'kartli-kakheti.png',
  sidesGeo: 'geo.png',
  sidesPersians: 'persians.png'
}

export const IMAGE_LIST = []